export default __webpack_public_path__ + "static/media/frank.fc6ca553.jpg";